module.exports = __webpack_public_path__ + "static/media/lumin-bottles-arranged-on-white-background.30c4e8f6.jpg";